import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AgGrid from '../../shared/agGrid/agGrid.component';

import { baseSlJournalColumnDefs } from '../../shared/columnDefinitions/slJournals';
import { grossAmountColumnDefinition } from '../../shared/columnDefinitions';

import { decodeCountryTaxType } from '../../utils/encodeDecodeCTT';

export const slJournalPropTypes = PropTypes.arrayOf(PropTypes.shape({
  TAX_YEAR: PropTypes.number,
  COMPANY_CODE: PropTypes.string,
  TRADING_PARTNER: PropTypes.string,
  SL_ACCOUNT: PropTypes.string,
  TE_ADJ_DESCRIPTION: PropTypes.string,
  CURRENCY_CODE: PropTypes.string,
  COUNTRY_TAX_TYPE: PropTypes.string,
  BOOK_TYPE: PropTypes.string,
  NET_AMOUNT: PropTypes.number,
  GROSS_AMOUNT: PropTypes.number,
})).isRequired;


const getSlJournalColumnDefs = (allowGross = false) => [
  ...baseSlJournalColumnDefs,
  ...(allowGross ? [{ ...grossAmountColumnDefinition, field: 'grossAmount' }] : []),
];

class ProposedSubledgerJournalGrid extends PureComponent {
  static propTypes = {
    slJournal: slJournalPropTypes,
    allowGross: PropTypes.bool,
  };

  static defaultProps = {
    allowGross: false,
  };

  componentDidUpdate(prevProps) {
    const grossAmountValueChanged = this.props.allowGross !== prevProps.allowGross;
    if (grossAmountValueChanged && this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  onGridReady = ({ api }) => this.gridApi = api;

  render() {
    const { slJournal, allowGross } = this.props;

    const columnDefinitions = getSlJournalColumnDefs(allowGross);

    const slJournalWithDecodedTaxTypes = slJournal.map(journal => {
      const { countryCode, countryTaxType } = decodeCountryTaxType(journal.countryTaxType);

      return {
        ...journal,
        countryCode,
        countryTaxType,
      };
    });

    return (
      <div className="proposed-subledger-journal-grid">
        <div className="ag-theme-bootstrap">
          <AgGrid
            columnDefs={columnDefinitions}
            headerHeight={50}
            domLayout="autoHeight"
            rowData={slJournalWithDecodedTaxTypes}
            onGridReady={this.onGridReady}
            suppressRowClickSelection
          />
        </div>
      </div>
    );
  }
}

export default ProposedSubledgerJournalGrid;
